export default function Section5() {
  return (
    <div className="Section5">
      <div className="section5-container md:flex w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px] pt-[10px] pb-[35px] md:py-[35px]">
        <div className="md:w-[58.33%] mb-[40px] md:mb-0 md:pr-[15px]">
          <h2 className="text-[24px] md:text-[34px] font-bold w-[85%] md:w-[50%] leading-[40px] my-[0.67em]">
            Run TikToK Ads with <span className="text-[#da2128]">Mean3</span>
          </h2>

          <p className="text-[#373737] leading-[1.2] md:leading-[22px] text-[12px] md:text-[14px] font-open mb-5">
            Businesses can now run TikTok ads with as low as $10/day, that
            enables you to tap:
          </p>

          <ul className="text-[#373737] ml-[40px] text-[12px] md:text-[14px] font-open leading-[1.4] md:leading-[1.2] mb-[10px] list-disc">
            <li>A new target Audience</li>
            <li>Increase Brand Awareness</li>
            <li>Increase Conversions</li>
            <li>Generate an audience pool through TikTok Pixel</li>
          </ul>
        </div>

        <div className="md:w-[41.66666667%] md:pl-[15px]">
          <img className="mx-auto md:mx-0" src="../../../../assets/laptop-tiktok.png"></img>
        </div>
      </div>
      <div className="line mt-[35px] mb-[60px] mx-auto w-[95%] md:w-[45%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
